<template>
    <div>
      <div class="class_add_top">
        <a onclick="history.go(-1)" class="back">返回</a>
      </div>
      <div class="signup_de_con">
        <h3>{{form.name}}</h3>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <thead>
          <tr>
            <td>用户ID</td>
            <td>报名类别</td>
            <td>报名金额</td>
            <td>支付时间</td>
            <td>状态(支付状态)</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in lists" :key="item.id">
            <td>{{item.userId}}</td>
            <td v-if="item.type == '01'">线上课程</td>
            <td v-if="item.type == '02'">直播</td>
            <td v-if="item.type == '03'">计划</td>
            <td v-if="item.type == '04'">线下课程</td>
            <td>￥{{item.cost}}</td>
            <td>{{item.payDate}}</td>
            <td>
              {{item.stateName}} / {{item.paystateName}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
    export default {
      created () {
        this.getModel(this.$route.params.id)
        this.getName(this.$route.params.id)
      },
      mounted () {
      },
      data () {
        return {
          lists: [],
          form: {},
          filters: {
            pageSize: 12,
            pageNo: 1
          },
          cntData: '',
          pages: 0
        }
      },
      methods: {
        getModel (id) {
          var that = this
          api.post(config.enrollApiPath, '/signupuser/search', { signupid: id, noUser: '1', pageNo: this.filters.pageNo, pageSize: this.filters.pageSize }, function (r) { // 正常
            that.lists = r.data
          })
        },
        getName (id) {
          var that = this
          api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, function (r) { // 正常
            that.form = r.data
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/confirm.vue